import React, { FC, ReactElement } from "react";

import { SvgIconProps } from "../Icon";

const IconCheckCircle: FC<SvgIconProps> = ({
  className = "",
}): ReactElement => (
  <svg fill="none" viewBox="0 0 59 59" className={className}>
    <path d="M29.2486 1.77293C29.2486 0.793257 28.4536 -0.00652814 27.4757 0.0528439C22.3139 0.366237 17.3158 2.04374 12.9984 4.92851C8.18836 8.14248 4.43938 12.7106 2.22556 18.0553C0.0117348 23.3999 -0.567504 29.281 0.561094 34.9549C1.68969 40.6287 4.47544 45.8405 8.56605 49.9311C12.6567 54.0217 17.8684 56.8074 23.5423 57.936C29.2161 59.0646 35.0972 58.4854 40.4419 56.2716C45.7865 54.0577 50.3546 50.3088 53.5686 45.4987C56.4534 41.1814 58.1309 36.1832 58.4443 31.0214C58.5037 30.0435 57.7039 29.2486 56.7242 29.2486C55.7445 29.2486 54.9567 30.0437 54.8892 31.0211C54.5809 35.4806 53.1137 39.7939 50.6188 43.5277C47.7947 47.7544 43.7806 51.0486 39.0842 52.9939C34.3878 54.9392 29.22 55.4482 24.2344 54.4565C19.2487 53.4648 14.6691 51.0169 11.0746 47.4225C7.48019 43.828 5.03233 39.2484 4.04062 34.2627C3.04891 29.2771 3.55789 24.1093 5.5032 19.4129C7.44851 14.7165 10.7428 10.7025 14.9694 7.87831C18.7032 5.38346 23.0165 3.9162 27.476 3.60795C28.4534 3.5404 29.2486 2.75259 29.2486 1.77293Z" />
    <path
      d="M17.6797 27.4374L25.6109 35.3686L42.8409 18.1387"
      strokeWidth="3.6"
      className="stroke"
    />
    <circle cx="38.3481" cy="3.31099" r="2.24654" />
    <circle cx="49.1313" cy="10.0512" r="2.24654" />
    <circle cx="54.9731" cy="19.936" r="2.24654" />
  </svg>
);

export default IconCheckCircle;
